import { ensureArray } from "./arrayUtilities"

export const resolveSitrepElementColor = (element, types = [], fallbackColor = null) => {
    if (typeof element?.color === "string") {
        return element.color;
    }

    const accessEntries = ensureArray(element?.access);
    let resolvedColor = null;
    let mismatch = false;
    accessEntries.forEach(accessEntry => {
        if (!accessEntry || !Array.isArray(types) || types.length === 0) {
            return
        }
        const accessType = accessEntry.type
        if (!accessType) {
            return
        }

        const site = accessEntry.site ?? null
        const level = accessEntry.level ?? null
        // Prefer the most specific type match, then relax level/site, then global.
        let match = types.find(t => (!site || t.site === site) && (!level || t.level === level) && t.type === accessType)
        if (!match) {
            match = types.find(t => (!site || t.site === site) && !t.level && t.type === accessType)
        }
        if (!match) {
            match = types.find(t => !t.site && (!level || t.level === level) && t.type === accessType)
        }
        if (!match) {
            match = types.find(t => !t.site && !t.level && t.type === accessType)
        }
        const color = typeof match?.color === "string" ? match.color : null
        if (!color) {
            return
        }
        if (!resolvedColor) {
            resolvedColor = color
            return
        }
        if (resolvedColor !== color) {
            mismatch = true
        }
    })

    if (resolvedColor && !mismatch) {
        return resolvedColor
    }
    return fallbackColor
}
